<template>
    <el-dialog title="数字人模型列表" :visible.sync="dialogVisible" width="90rem">
        <div class="list-box">
            <div v-for="(item,index) in modelList" :class="{'model-active':item.id==currentModelId}" class="model-item" :key="index">
                <div class="top-el">
                    <img :src="item.coverPath" alt="">
                    <p class="text-name">{{ item.name }}</p>
                    <i v-if="item.id==currentModelId" class="iconfont icon-dagou"></i>
                </div>
                <div class="bottom-el">
                    <div class="li-item">
                        创建人：{{ item.userName }}
                    </div>
                    <div class="li-item">
                        创建时间：{{ getDateTime(new Date(item.createTime).getTime()) }}
                    </div>
                    <button class="button-primary" @click="changeModel(item)">
                        <i class="iconfont icon-weibiaoti518"></i>
                        启动</button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { GetDigitalHumanModelList } from '@/api/numberPerson';
import { getDateTime } from '@/utils/utils';
export default {
    data(){
        return{
            dialogVisible:false,
            modelList:[],
        }
    },
    computed:{
        currentModelId(){
            return this.$store.state.course.currentModelId;
        }
    },
    methods:{
        getDateTime,
        changeModel(item){
            this.$store.commit('course/changeModel',item.id);
        },
        getDigitalHumanModelList(){
            let loginName='gyy'||this.$store.state.user.userInfo.id;
            GetDigitalHumanModelList(loginName).then(res=>{
                if(res.code==200){
                    this.modelList=res.data;
                    this.dialogVisible=true;
                    if(this.modelList.length>0&&!this.currentModelId){
                        this.changeModel(this.modelList[0]);
                    }
                }
            })
        }
    },
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/globalCard.less";
@import "../../../assets/css/aiCommon.less";
.model-active{
    border: 2px solid #fdbb2d !important;
    box-shadow: 0 0 2rem rgba(253, 187, 45, 0.4) !important;
    transform: translateY(-5px);
}
/deep/.el-dialog__body {
    padding-top: 0 !important;
}

/deep/.el-dialog {
    border-radius: 2rem;
    background: linear-gradient(135deg, #1a2a6c, #b21f1f, #fdbb2d);
    color: #ffffff;
}
/deep/.el-dialog__title{
    color: #ffffff;
    font-weight: 700;
}
.list-box{
    display: flex;
    flex-wrap:wrap ;
    .model-item{
        width: calc((100% - 6rem) / 3);
        height: 35rem;
        margin-left: 3rem;
        margin-top: 2rem;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border-radius: 16px;
        overflow: hidden;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: all 0.3s;
    }
    &> :nth-child(3n+1){
        margin-left: 0 !important;
    }
}
.top-el{
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 50%;
    justify-content: center;
    position: relative;
    img{
        width: 11rem;
        height: 11rem;
        object-fit: cover;
        border-radius: 50%;
    }
    .text-name{
        font-weight: 700;
        font-size: 2rem;
        margin-top: 1.5rem;
        color: #ffffff;
    }
}
.bottom-el{
    background: rgba(0, 0, 0, 0.2);
    height: 50%;
    padding: 2rem;
    .li-item{
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        padding:1rem 0;
        color: #ffffff;
    }
    .button-primary{
        background: linear-gradient(to right, #3498db, #2ecc71);
        color: white;
        padding: 1rem 2rem;
        border-radius: 3rem;
        border: none;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        margin-top: 2rem;
    }
}
.icon-dagou{
    color: #fdbb2d;
    position: absolute;
    right: 2rem;
    top: 2rem;
    font-size: 3rem;
}
@media screen and (max-width:750px){
    /deep/.el-dialog{
        width: 58rem !important;
    }
}
</style>